import { hashCode } from 'hashcode';

const get = (facetId, facetValue) => {
  return `id:${hashCode().value(`${facetId}${facetValue}`)}`;
};

export default get;
